module.exports = __webpack_public_path__ + "img/solution3-banner.8b2d686b.jpg";